import React from 'react';
import { func, shape, number } from 'prop-types';
import { Pill } from './Pill';
import styles from './article-listing-filters.module.scss';

const groupLabels = {
  informationTypeCounts: 'Information Type',
  brands: 'Brand',
  homeAreas: 'Home Area',
  keywords: 'Keyword',
  seasons: 'Season',
  regions: 'Region',
};

const FilterPills = ({ filterGroups, toggleChecked, clearAllFilters, totalArticles }) => {
  if (!filterGroups) return null;
  const filterGroupKeys = Object.keys(filterGroups);
  const filterPillsArray = filterGroupKeys.length
        && filterGroupKeys.reduce((acc, group, indexi) => {
          if (!Array.isArray(filterGroups[group]) || !filterGroups[group].length) return acc;
          return [
            ...acc,
            ...filterGroups[group].reduce((accu, { isCurrentPage, title, id }, indexj) => {
              if (!isCurrentPage) return accu;
              return [
                ...accu,
                <Pill
                  key={indexi + '' + indexj}
                  id={id}
                  label={groupLabels[group]}
                  title={title}
                  toggleChecked={toggleChecked}
                />
              ];
            }, [])
          ];
        }, []);

  return (
    <div className={styles['filter-pills']}>
      <span className={styles['total-articles']}>{totalArticles} Result{totalArticles !== 1 ? 's' : ''}</span>
      {filterPillsArray}
      {!!filterPillsArray.length
        && <button className={styles['clear-all']} type="button" onClick={clearAllFilters}>Clear All</button>}
    </div>
  );
};

FilterPills.propTypes = {
  filterGroups: shape({}).isRequired,
  toggleChecked: func.isRequired,
  clearAllFilters: func.isRequired,
  totalArticles: number
};

FilterPills.defaultProps = {
  totalArticles: 0
};

export { FilterPills };